export function canonicalTimezone(value) {
  try { return value ? new Intl.DateTimeFormat('en', {timeZone:value}).resolvedOptions().timeZone : null; } catch { return null; }
}
export function findTimezoneOption(zones, value) {
  const exact=zones.find(zone=>String(zone.id)===String(value) || zone.timezone===value || zone.timezone===value?.timezone);
  if(exact)return exact;
  const canonical=canonicalTimezone(value?.timezone || value);
  return canonical ? zones.find(zone=>canonicalTimezone(zone.timezone)===canonical) : undefined;
}
export function timezoneOffset(value, at=new Date()) {
  try { return new Intl.DateTimeFormat('en',{timeZone:value,timeZoneName:'longOffset'}).formatToParts(at).find(part=>part.type==='timeZoneName')?.value.replace('GMT','UTC') || 'UTC'; } catch { return ''; }
}
export function timezoneDisplayName(value) {
  if (!value) return 'Your local timezone';
  const city = String(value).split('/').pop().replaceAll('_', ' ');
  try {
    const name = new Intl.DateTimeFormat('en-US', {timeZone:value, timeZoneName:'longGeneric'}).formatToParts(new Date()).find(part=>part.type==='timeZoneName')?.value;
    return name && name !== city ? `${name} — ${city}` : city;
  } catch { return city; }
}
export function searchTimezones(zones, query) {
  const normalized=String(query||'').trim().toLowerCase().replaceAll('_',' ');
  return zones.filter(zone=>`${zone.name} ${zone.timezone.replaceAll('_',' ')} ${zone.region?.name||''}`.toLowerCase().includes(normalized));
}
